import "layouts/Home/Home.css";
import React from "react";
import {request} from "../../../api-client";
import {TableButton, TableButtonsBuilder} from "../../../components/Letflow/Table";
import ProjectsImage from "../../../assets/img/Letflow/projects.jpg";
import localization from "../../../config/localization";
import {Edit, MoreVert, People, Share} from "@material-ui/icons";
import ParticipantsButton from "../../../views/Pitches/Thread/ParticipantsButton";
import {makeImageUrlWithSize} from "../HomeElements/utils";
import Folder from "../../../assets/img/Letflow/folder.png";
import moment from "moment";
import {IconButton, MenuItem} from "@material-ui/core";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import Delete from "@material-ui/icons/Delete";
import GlobalConfirmationDialog from "../../../components/Letflow/Dialog/GlobalConfirmationDialog";

class ProjectItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
  }

  buildButtons = (project) => {
    let builder = new TableButtonsBuilder();
        builder
          .withOther(
            <ParticipantsButton
              small={true}
              tooltip="top"
              //clientsIds={this.state.clients.map(client => client.id)}
              pitchId={project.id}
              //participants={this.state.participants}
              //clients={this.state.clients}
            />
          );

      builder
        .withOther(
          <TableButton
            title={localization.get('edit')}
            onClick={() => this.props.onEdit(project)}
          >
            <Edit/>
          </TableButton>
        );

      builder
        .withDelete(
          project.project_name,
          () => request.pitch.delete(project.id),
          closeState => {
            if (closeState === 'passed') {
              this.props.onDelete && this.props.onDelete(project.id)
            }
          }
        )

    return builder.build()
  }

  render = () => {
    const { project, onClick } = this.props;

      return (
        <div
          onClick={onClick}
          style={{
            position: "relative",
            float: "left",
            width: "100%",
            padding: 10,
            cursor: "pointer",
          }}>
          <div style={{
            position: "relative",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            float: "right",
            width: "100%",
            height: 185,
            backgroundImage: `url(${Folder})`
          }}>
            {project && project.image && <img
              src={request.file.image.makeCroppedUrl(project.image.id, 200, 150, 'file', 'jpg')}
              style={{
                inset: "0px",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                cursor: "pointer",
                width: "180px",
                height: "120px",
                marginTop: "45px",
                borderRadius: 10,
              }}/>
            }
          </div>
          <div className="playlist-info-data">
            <div>
              <h3 style={{
                margin: 0,
                fontSize: 18,
                textAlign: "left"
              }}>{project.project_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}</h3>
              <h4 style={{
                margin: 0,
                fontSize: 11,
                textAlign: "left"
              }}> {localization.get('last_update')} {moment(project.updated_at).format('DD/MM/YY')}</h4>
            </div>
            <div
              aria-describedby={project.id}
              ref={node => this.anchorEl = node}
              aria-owns={this.state.open ? "menu-list-grow" : null}
              aria-haspopup="true"
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                this.setState({open: !this.state.open})
              }}
            >
              <IconButton>
                <MoreVert/>
              </IconButton>
            </div>
            <Popper
              open={this.state.open}
              id={project.id}
              anchorEl={this.anchorEl}
              transition
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              style={{zIndex: 1400}}
            >
              {({TransitionProps, placement}) => (
                <Grow
                  {...TransitionProps}
                  id="menu-list-grow"
                  style={{transformOrigin: "center right", zIndex: 10}}
                >
                  <Paper style={{zIndex: 10}}>
                    <ClickAwayListener onClickAway={() => this.setState({open: false})}>
                      <MenuList
                        style={{paddingBottom: 0, paddingTop: 0, minWidth: 250,}}>
                        <MenuItem
                          onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            GlobalConfirmationDialog.showDelete({
                              elementName: project.project_name,
                              deleteRequest: () => request.pitch.delete(project.id),
                              onSuccess: () => this.props.onDelete(project.id),
                              doubleConfirmation: true,
                            })
                            this.setState({open: false})
                          }}
                          style={{color: "#525252"}}>
                          <Delete/>
                          <span style={{marginLeft: 5}}>{localization.get('delete')}</span>
                        </MenuItem>
                        <MenuItem
                          style={{color: "#525252"}}
                          onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            this.props.onEdit(project)
                            this.setState({open: false})
                          }}>
                          <Edit/>
                          <span style={{marginLeft: 5}}>{localization.get('edit')}</span>
                        </MenuItem>
                        <MenuItem
                          style={{color: "#525252"}}
                          onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            this.props.onParticipantsClick(project)
                            this.setState({open: false})
                          }}>
                          <People style={{fontSize: '16px', marginRight: '10px'}}/>
                          <span style={{marginLeft: 5}}>{localization.get('participants')}</span>
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </div>
      )
  }
}
export default ProjectItem
